/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NameType } from '../../models/name-type';

export interface Callback$Params {
  state?: NameType;
  code?: NameType;
  error?: NameType;
  error_description?: NameType;
}

export function callback(http: HttpClient, rootUrl: string, params?: Callback$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'errorMessage': NameType;
}>> {
  const rb = new RequestBuilder(rootUrl, callback.PATH, 'get');
  if (params) {
    rb.query('state', params.state, {});
    rb.query('code', params.code, {});
    rb.query('error', params.error, {});
    rb.query('error_description', params.error_description, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'errorMessage': NameType;
      }>;
    })
  );
}

callback.PATH = '/auth/callback';
